import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=42fb68c2"
import script from "./EventHistory.vue?vue&type=script&lang=js"
export * from "./EventHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports